// Swiper initialization and synchronization for CFL MS 25 Characters
// This module sets up:
// - Main thumb/content swipers
// - Per-slide child thumb/content swipers
// - Auto-init for dynamically added slides
// - Updates on parent slide change and when tabs are shown (via custom event)

window.addEventListener("load", function () {
  var section = document.querySelector('#cfl-ms-25-characters');
  if (!section) return;

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function getChildThumbDirection() {
    return isMobile() ? 'vertical' : 'horizontal';
  }

  function getChildThumbSpaceBetween() {
    return isMobile() ? 4 : 24;
  }

  function updateAllSwipersIn(rootEl) {
    if (!rootEl) return;
    $(rootEl).find('.swiper').each(function () {
      var inst = this && this.swiper;
      if (inst && typeof inst.update === 'function') inst.update();
    });
  }

  // Ensure child nav buttons in a given content container are bound once
  // Falls back to controlling the root content swiper if no child swipers exist
  function ensureChildNavBinding(contentContainer) {
    if (!contentContainer || contentContainer.__childNavBound) return;
    var nextBtn = contentContainer.querySelector('.swiper-characters-thumb-child-next');
    var prevBtn = contentContainer.querySelector('.swiper-characters-thumb-child-prev');
    var clickHandler = function (dir) {
      return function (e) {
        e.preventDefault();
        var rootContentSwiper = contentContainer.swiper;
        if (!rootContentSwiper) return;
        var activeIdx = rootContentSwiper.activeIndex || 0;
        var activeSlideEl = rootContentSwiper.slides && rootContentSwiper.slides[activeIdx];
        var childPair = initChildPairForSlide(activeSlideEl);
        var hasChild = !!(childPair && childPair.content);

        if (hasChild) {
          var targetSwiper = childPair.content;
          if (dir === 'slideNext') {
            if (!targetSwiper.isEnd) {
              targetSwiper.slideNext();
              if (childPair.content.thumbs && typeof childPair.content.thumbs.update === 'function') {
                childPair.content.thumbs.update();
              }
              return;
            }
            if (!rootContentSwiper.isEnd && typeof rootContentSwiper.slideNext === 'function') {
              var afterSwitch = function () {
                var newIdx = rootContentSwiper.activeIndex || 0;
                var newSlideEl = rootContentSwiper.slides && rootContentSwiper.slides[newIdx];
                var newPair = initChildPairForSlide(newSlideEl);
                if (newPair) {
                  var setIndex = 0;
                  if (newPair.content && typeof newPair.content.slideTo === 'function') newPair.content.slideTo(setIndex);
                  if (newPair.thumb && typeof newPair.thumb.slideTo === 'function') newPair.thumb.slideTo(setIndex);
                  if (newPair.content.thumbs && typeof newPair.content.thumbs.update === 'function') newPair.content.thumbs.update();
                }
                if (typeof rootContentSwiper.off === 'function') rootContentSwiper.off('slideChangeTransitionEnd', afterSwitch);
              };
              if (typeof rootContentSwiper.on === 'function') rootContentSwiper.on('slideChangeTransitionEnd', afterSwitch);
              rootContentSwiper.slideNext();
            }
          } else if (dir === 'slidePrev') {
            if (!targetSwiper.isBeginning) {
              targetSwiper.slidePrev();
              if (childPair.content.thumbs && typeof childPair.content.thumbs.update === 'function') {
                childPair.content.thumbs.update();
              }
              return;
            }
            if (!rootContentSwiper.isBeginning && typeof rootContentSwiper.slidePrev === 'function') {
              var afterSwitchPrev = function () {
                var newIdx2 = rootContentSwiper.activeIndex || 0;
                var newSlideEl2 = rootContentSwiper.slides && rootContentSwiper.slides[newIdx2];
                var newPair2 = initChildPairForSlide(newSlideEl2);
                if (newPair2) {
                  var last = (newPair2.content && newPair2.content.slides) ? newPair2.content.slides.length - 1 : 0;
                  if (newPair2.content && typeof newPair2.content.slideTo === 'function') newPair2.content.slideTo(last);
                  if (newPair2.thumb && typeof newPair2.thumb.slideTo === 'function') newPair2.thumb.slideTo(last);
                  if (newPair2.content.thumbs && typeof newPair2.content.thumbs.update === 'function') newPair2.content.thumbs.update();
                }
                if (typeof rootContentSwiper.off === 'function') rootContentSwiper.off('slideChangeTransitionEnd', afterSwitchPrev);
              };
              if (typeof rootContentSwiper.on === 'function') rootContentSwiper.on('slideChangeTransitionEnd', afterSwitchPrev);
              rootContentSwiper.slidePrev();
            }
          }
          return;
        }

        // Fallback: no child swipers in this content -> control root content directly
        if (dir === 'slideNext' && typeof rootContentSwiper.slideNext === 'function') {
          rootContentSwiper.slideNext();
        } else if (dir === 'slidePrev' && typeof rootContentSwiper.slidePrev === 'function') {
          rootContentSwiper.slidePrev();
        }
      };
    };
    if (nextBtn) nextBtn.addEventListener('click', clickHandler('slideNext'));
    if (prevBtn) prevBtn.addEventListener('click', clickHandler('slidePrev'));
    contentContainer.__childNavBound = true;
  }

  function initChildPairForSlide(slideEl) {
    if (!slideEl) return null;
    var $slide = $(slideEl);
    var existing = $slide.data('childPair');
    if (existing) return existing;

    // Child swipers are no longer used. Just ensure nav buttons in the parent
    // content container are bound to control the root content swiper.
    var contentContainer = $slide.closest('.swiper-characters-content').get(0);
    ensureChildNavBinding(contentContainer);

    // Store a sentinel to avoid rebinding work on subsequent calls
    var pair = null;
    $slide.data('childPair', pair);
    return pair;
  }
  

  function initChildPairsIn(root) {
    if (!root) return;
    $(root).find('.swiper-characters-content .swiper-slide').each(function () {
      initChildPairForSlide(this);
    });
  }

  // Ensure clicking on a thumb slide switches the main content (works even when drag is disabled on desktop)
  function ensureThumbClickBinding(thumbRoot, contentSwiper) {
    if (!thumbRoot || !contentSwiper || thumbRoot.__thumbClickBound) return;
    thumbRoot.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var slide = target.closest('.swiper-slide');
      if (!slide || !thumbRoot.contains(slide)) return;
      // Map clicked slide to its index among visible slides (no loop mode assumed)
      var slides = Array.prototype.slice.call(thumbRoot.querySelectorAll('.swiper-slide'));
      var idx = slides.indexOf(slide);
      if (idx < 0) return;
      if (typeof contentSwiper.slideTo === 'function') {
        e.preventDefault();
        e.stopPropagation();
        contentSwiper.slideTo(idx);
      }
    });
    thumbRoot.__thumbClickBound = true;
  }

  // Update active state for thumb slides based on content index (works without Swiper thumbs auto-sync)
  function updateThumbActive(thumbRoot, contentSwiper) {
    if (!thumbRoot || !contentSwiper) return;
    var idx = contentSwiper.activeIndex || 0;
    var slides = thumbRoot.querySelectorAll('.swiper-slide');
    if (!slides || !slides.length) return;
    for (var i = 0; i < slides.length; i++) {
      if (i === idx) slides[i].classList.add('swiper-slide-thumb-active');
      else slides[i].classList.remove('swiper-slide-thumb-active');
    }
  }

  // Prevent thumb swiper from auto-scrolling on desktop by patching slideTo
  function applyThumbNoScrollPatch(inst) {
    var onMobile = isMobile();
    if (!inst) return;
    // Ensure slideToClickedSlide only on mobile
    if (inst.params) inst.params.slideToClickedSlide = onMobile;
    if (!onMobile) {
      if (!inst.__origSlideTo) inst.__origSlideTo = inst.slideTo;
      if (!inst.__patchedNoScroll) {
        inst.slideTo = function () { return 0; };
        inst.__patchedNoScroll = true;
      }
    } else if (inst.__patchedNoScroll && inst.__origSlideTo) {
      inst.slideTo = inst.__origSlideTo;
      inst.__patchedNoScroll = false;
    }
  }

  // Initialize one main swiper pair per tab-content
  function initMainPairInTab(tabEl) {
    if (!tabEl) return null;
    var $tab = $(tabEl);
    var existing = $tab.data('mainPair');
    if (existing) return existing;

    var thumbRoot = tabEl.querySelector('.swiper-characters-thumb');
    var contentRoot = tabEl.querySelector('.swiper-characters-content');
    if (!thumbRoot || !contentRoot) return null;
    if (!thumbRoot.querySelector('.swiper-wrapper') || !contentRoot.querySelector('.swiper-wrapper')) return null;

    // Ensure navigation buttons exist (scoped inside this thumbRoot)
    function ensureThumbNavButtons(root) {
      var next = root.querySelector('.swiper-characters-thumb-next');
      var prev = root.querySelector('.swiper-characters-thumb-prev');
      
      return { next: next, prev: prev };
    }

    var navBtns = ensureThumbNavButtons(thumbRoot);

    var thumbSwiper = thumbRoot.swiper || new Swiper(thumbRoot, {
      direction: isMobile() ? 'horizontal' : 'vertical',
      slidesPerView: isMobile() ? 5 : 8,
      // Disable dragging on desktop to avoid page scroll drift; keep swipe on mobile
      allowTouchMove: isMobile(),
      simulateTouch: isMobile(),
      mousewheel: false,
      
      centerInsufficientSlides: isMobile(),
      watchSlidesProgress: true,
  slideToClickedSlide: isMobile(),
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      navigation: {
        nextEl: navBtns.next,
        prevEl: navBtns.prev,
      },
    });

    // Prevent thumbs from auto-scrolling on desktop immediately on init
    applyThumbNoScrollPatch(thumbSwiper);

    var contentSwiper = contentRoot.swiper || new Swiper(contentRoot, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    });

    // Ensure child nav buttons for this content are bound regardless of child initialization
    ensureChildNavBinding(contentRoot);

    // Ensure clicking on thumb items switches content (especially for desktop where drag is disabled)
    ensureThumbClickBinding(thumbRoot, contentSwiper);
  // Keep thumb active class in sync with content
  updateThumbActive(thumbRoot, contentSwiper);

    // Link thumbs to content
    contentSwiper.params.thumbs = { swiper: thumbSwiper };
    if (contentSwiper.thumbs && typeof contentSwiper.thumbs.init === 'function') {
      contentSwiper.thumbs.init();
      if (typeof contentSwiper.thumbs.update === 'function') contentSwiper.thumbs.update();
    }

    // When this tab's content changes slide, update its child pair if exists
    contentSwiper.on('slideChangeTransitionEnd', function () {
      var activeIndex = contentSwiper.activeIndex || 0;
      var activeSlideEl = contentSwiper.slides && contentSwiper.slides[activeIndex];
      var pair = initChildPairForSlide(activeSlideEl);
      if (pair) {
        if (pair.thumb && pair.thumb.update) pair.thumb.update();
        if (pair.content && pair.content.update) pair.content.update();
      }
      // Keep thumb active state synced without moving the thumb list on desktop
      updateThumbActive(thumbRoot, contentSwiper);
    });

    var pair = { thumb: thumbSwiper, content: contentSwiper };
    $tab.data('mainPair', pair);
    return pair;
  }

  function initForActiveTab() {
    var activeTab = section.querySelector('.tab-content.active') || section.querySelector('.tab-content');
    if (!activeTab) return;
    var mainPair = initMainPairInTab(activeTab);
    // Init any child pairs inside this tab
    initChildPairsIn(activeTab);
    // Update size and active child pair
    requestAnimationFrame(function () {
      updateAllSwipersIn(activeTab);
      if (mainPair) {
        if (mainPair.thumb && mainPair.thumb.update) mainPair.thumb.update();
        if (mainPair.content && mainPair.content.update) mainPair.content.update();
        var idx = mainPair.content.activeIndex || 0;
        var activeSlideEl = mainPair.content.slides && mainPair.content.slides[idx];
        var child = initChildPairForSlide(activeSlideEl);
        if (child) {
          if (child.thumb && child.thumb.update) child.thumb.update();
          if (child.content && child.content.update) child.content.update();
        }
      }
    });
  }

  // Initialize for the active tab on load
  initForActiveTab();

  // Also initialize other tab contents (so each has its own content/ thumb swipers ready)
  $(section).find('.tab-content').each(function () {
    initMainPairInTab(this);
  });

  // Init existing children
  initChildPairsIn(section);

  // React when tabs are shown (custom event triggered by main script)
  $('#cfl-ms-25-characters').on('tab:shown', function () {
    initForActiveTab();
    // ensure child nav targets the current active child after tab switch
    updateChildThumbDirections(section);
  });

  // Auto-init for dynamically added slides
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.matches && node.matches('.swiper-characters-content .swiper-slide')) {
            initChildPairForSlide(node);
          } else {
            $(node).find('.swiper-characters-content .swiper-slide').each(function () {
              initChildPairForSlide(this);
            });
          }
        });
      });
    });
    observer.observe(section, { childList: true, subtree: true });
  }

  // Handle direction change on resize for child thumb swipers
  function updateChildThumbDirections(rootEl) {
    // No longer using separate child thumb swipers; just ensure child content swipers (if any) update
    $(rootEl || section).find('.swiper-characters-content').each(function () {
      var inst = this && this.swiper;
      if (inst && typeof inst.update === 'function') inst.update();
    });
  }

  // Handle main thumb responsive behavior (direction + show/hide nav)
  function updateMainThumbs(rootEl) {
    var makeHorizontal = isMobile();
    $(rootEl || section).find('.swiper-characters-thumb').each(function () {
      var root = this;
      var inst = root && root.swiper;
      if (!inst) return;
      var targetDir = makeHorizontal ? 'horizontal' : 'vertical';
      if (inst.params && inst.params.direction !== targetDir && typeof inst.changeDirection === 'function') {
        inst.changeDirection(targetDir);
      }
      // Update slidesPerView dynamically on resize breakpoint
      var targetSpv = makeHorizontal ? 5 : 8;
      if (inst.params && inst.params.slidesPerView !== targetSpv) {
        inst.params.slidesPerView = targetSpv;
      }
      // Toggle touch interactions: enable on mobile, disable on desktop
      inst.allowTouchMove = makeHorizontal;
      if (inst.params) {
        inst.params.simulateTouch = makeHorizontal;
        inst.params.mousewheel = false;
      }
      // Prevent auto-scroll of thumbs on desktop
      applyThumbNoScrollPatch(inst);
      // Center insufficient slides only on mobile
      inst.params.centerInsufficientSlides = makeHorizontal;
      // Toggle navigation visibility based on mobile
      var nextBtn = root.querySelector('.swiper-characters-thumb-next');
      var prevBtn = root.querySelector('.swiper-characters-thumb-prev');
      // Show nav on mobile, hide on desktop to keep thumb list static
      if (nextBtn) nextBtn.style.display = makeHorizontal ? '' : 'none';
      if (prevBtn) prevBtn.style.display = makeHorizontal ? '' : 'none';
      if (typeof inst.update === 'function') inst.update();
    });
  }

  // Initial responsive adjustment for main thumbs
  updateMainThumbs(section);
  updateChildThumbDirections(section);

  // Debounced resize to update both main and child thumb swipers
  var __resizeTimer;
  window.addEventListener('resize', function () {
    if (__resizeTimer) clearTimeout(__resizeTimer);
    __resizeTimer = setTimeout(function () {
      updateMainThumbs(section);
      updateChildThumbDirections(section);
    }, 150);
  });
  
});
